// The @microsoft/signalr package does not work with non-.NET Core WebApi, even if using the Azure SignalR service as the backplane
import { hubConnection } from 'signalr-asp-net';

const isDev = process.env.NODE_ENV === 'development';

const startSignalRConnection = async connection => {
  try {
    connection.start()
      .done(() => {
        //console.assert(connection.state === "Connected");
        //console.log('SignalR connection established');
      })
      .fail(() => {
        //console.assert(connection.state === "Disconnected");
        //console.error('SignalR Connection Error; retry in 5 seconds ');
        setTimeout(() => startSignalRConnection(connection), 5000);
      });
  } catch (err) {
    //console.assert(connection.state === "Disconnected");
    //console.error('SignalR Connection Error: ', err);
    setTimeout(() => startSignalRConnection(connection), 5000);
  }
};

export const SignalRConnectionStatus_NotConnected = -12345;
export const SignalRConnectionStatus_Connecting = 0;
export const SignalRConnectionStatus_Connected = 1;
export const SignalRConnectionStatus_Reconnecting = 2;
export const SignalRConnectionStatus_Disconnected = 4;
const signalRConnectionStatus = [
  "Connecting",
  "Connected",
  "Reconnecting",
  null,
  "Disconnected"
];
export const SignalRConnectionStatus = (state) => signalRConnectionStatus[state] || "Unknown " + state;

// Set up a SignalR connection to the specified hub URL, and actionEventMap.
// actionEventMap should be an object mapping event names, to eventHandlers that will
// be dispatched with the message body.
export const setupSignalRConnection = (connectionUrl, hubName, querystringParams, actionEventMap = {}, getAccessToken) => (dispatch, getState) => {
  const options = {
    logMessageContent: isDev,
    logging: isDev,
    accessTokenFactory: () => getAccessToken(getState()),
    qs: querystringParams
  };

  // create the connection instance
  // withAutomaticReconnect will automatically try to reconnect
  // and generate a new socket connection if needed
  const connection = hubConnection(connectionUrl, options);
  const hub = connection.createHubProxy(hubName);
  hub.qs = querystringParams;
  connection.logging = isDev;
  hub.logging = isDev;

  // Note: to keep the connection open the serverTimeout should be
  // larger than the KeepAlive value that is set on the server
  // keepAliveIntervalInMilliseconds default is 15000 and we are using default
  // serverTimeoutInMilliseconds default is 30000 and we are using 60000 set below
  connection.serverTimeoutInMilliseconds = 60000;

  // re-establish the connection if connection dropped

  /*
  connection.disconnected(error => {
    //console.assert(connection.state === HubConnectionState.Disconnected);
    console.log('Connection closed due to error. Try refreshing this page to restart the connection', error);
  });

  connection.reconnecting(error => {
    //console.assert(connection.state === HubConnectionState.Reconnecting);
    console.log('Connection lost due to error. Reconnecting.', error);
  });

  connection.reconnected(connectionId => {
    //console.assert(connection.state === HubConnectionState.Connected);
    console.log('Connection reestablished. Connected with connectionId', connectionId);
  });
*/

  Object.keys(actionEventMap).forEach((k) => {
    const eventName = k;
    hub.on(eventName, res => {
      const eventHandler = actionEventMap[eventName];
      eventHandler && dispatch(eventHandler(res));
    });
  });

  startSignalRConnection(connection);

  return connection;
};
